export const OVERRIDE_TYPES_KEYS = {
  startTime: "startTime",
  endTime: "endTime",
};

export const OVERRIDE_TYPES = {
  [OVERRIDE_TYPES_KEYS.startTime]: "Service Window Start Time",
  [OVERRIDE_TYPES_KEYS.endTime]: "Service Window End Time",
};

export const OVERRIDE_OPERATORS = {
  equal: "=",
  greaterThen: ">",
  greaterThenOrEqual: ">=",
  lessThen: "<",
  lessThenOrEqual: "<=",
};

export const DEFAULT_OVERRIDE = {
  outer: "",
  sector: "",
  postcode: "",
  overrideUuid: null,
  routeCode: null,
  uiOverrideStartTime: null,
  uiOverrideEndTime: null,
  startOperator: null,
  startEarliestTime: "1970-01-01T00:00:00.000000000Z",
  startLatestTime: "1970-01-01T23:59:00.000000000Z",
  endOperator: null,
  endEarliestTime: "1970-01-01T00:00:00.000000000Z",
  endLatestTime: "1970-01-01T23:59:00.000000000Z",
  excludeOneHour: false,
};

export const DEFAULT_OVERRIDE_ROW = {
  selectType: "",
  operatorType: "",
  selectTime: "",
};

export const OVERRIDE_MAPPING = {
  OUTER: {
    postcodeKey: "postcodeOuter",
  },
  SECTOR: {
    postcodeKey: "postcodeSector",
  },
  POSTCODE: {
    postcodeKey: "postcode",
  },
};
